import BaseTrackingController from "../../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../model/InteractionEventName";
import CollaborationDialogPlayer from "../../ngt/dialog/CollaborationDialogPlayer";
import GameModel from "../../core/model/GameModel";
import OptionData from "../../core/model/OptionData";

export default class TrackingController extends BaseTrackingController {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, gameModel) {
        super(dispatcher);
        this._gameModel = gameModel;
        this._dispatcher.addEventListener(CollaborationDialogPlayer.OPTION_CHOSEN, this._handleOptionChosen.bind(this));
    }

    _handleOptionChosen({ params: optionData }) {
        this.trackDialogOption(optionData);
    }

    /**
     * @param {ProgressValue} value 
     */
    trackProgress(value) {
        this._dispatchProgressEvent(value, this._gameModel.elapsedTime);
    }

    /**
     * @param {OptionData} optionData 
     */
    trackDialogOption(optionData) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_OPTION_CHOSEN,
            {
                dialog_id: optionData.dialogId,
                situation_id: optionData.situationId,
                option_id: optionData.optionId,
                correct: optionData.isCorrect,
                skill: optionData.skill,
                behaviour: optionData.behaviour,
                time_to_answer: optionData.timeToAnswer
            },
            this._gameModel.elapsedTime
        );
    }

    /**
     * @param {String} dialogId 
     */
    trackDialogStart(dialogId) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_STARTED,
            { dialog_id: dialogId },
            this._gameModel.elapsedTime
        );
    }

    /**
     * @param {String} dialogId 
     */
    trackDialogEnd(dialogId) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_ENDED,
            { dialog_id: dialogId },
            this._gameModel.elapsedTime
        );
    }


    _puzzleIdFromIndex(puzzleIdx) {
        //convert index to 'id' 
        return puzzleIdx + 1;
    }

}
